import { createContext, useContext, useEffect, useState } from "react";
import { getMe } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null=checking, false=unauth, obj=auth

  useEffect(() => {
    const token = localStorage.getItem("cascade_token");
    if (!token) { setAdmin(false); return; }
    getMe().then(setAdmin).catch(() => { localStorage.removeItem("cascade_token"); setAdmin(false); });
  }, []);

  const signIn = (token, user) => {
    localStorage.setItem("cascade_token", token);
    setAdmin(user);
  };
  const signOut = () => {
    localStorage.removeItem("cascade_token");
    setAdmin(false);
  };

  return <AuthContext.Provider value={{ admin, signIn, signOut }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
